import { Component, Prop, Ref, log, useProp } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class ErrorPage extends ThemeComponent {

}
